<template>
  <div>
    <legend>Отчет №1</legend>
    <div class="form-group mb-3 mx-auto" style="max-width: 200px">
      <date-picker class="w-100" v-model="date" valueType="format"
                   placeholder="Дата отчета"
                   :input-attr="{required: true}"
                   input-class="form-control"
                   :first-day-of-week="1" lang="ru">
      </date-picker>
    </div>
    <div class="overflow-auto">
    <div class="d-table-row">
    <template v-for="cs in report.categoryStats">
      <table class="table table-sm table-bordered table-responsive small text-center d-table-cell w-auto">
        <thead>
        <tr>
          <th colspan="6">{{cs.CustomerCategory.Name}}</th>
        </tr>
        <tr>
          <th></th>
          <th width="100">Отправлено вчера</th>
          <th width="100">Доставлено вчера</th>
          <th width="100">Оплачено вчера</th>
          <th width="100">Оплачено долги</th>
          <th width="100">Долг</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Заказы</td>
          <td>
            {{sumCountOrder(cs.stats.dispatchYesterday)}}
          </td>
          <td>
            {{sumCountOrder(cs.stats.deliveredYesterday)}}
          </td>
          <td>
            {{sumCountOrder(cs.stats.ordersPaidYesterday)}}
          </td>
          <td>
            {{sumCountOrder(cs.stats.ordersDebtYesterday)}}
          </td>
          <td>
            {{sumCountOrder(cs.stats.ordersFullDebt)}}
          </td>
        </tr>
        <tr>
          <td>Штуки</td>
          <td>
            {{sumCountAmount(cs.stats.dispatchYesterday)}}
          </td>
          <td>
            {{sumCountAmount(cs.stats.deliveredYesterday)}}
          </td>
          <td>
            {{sumCountAmount(cs.stats.ordersPaidYesterday)}}
          </td>
          <td>
            {{sumCountAmount(cs.stats.ordersDebtYesterday)}}
          </td>
          <td>
            {{sumCountAmount(cs.stats.ordersFullDebt)}}
          </td>
        </tr>
        <template v-for="pType in report.pTypes">
          <tr>
            <td>
              {{pType.Name}}
            </td>
            <td>
              {{getSummaryByPaymentTypeId(pType.Id, cs.stats.dispatchYesterday)}}
            </td>
            <td>
              {{getSummaryByPaymentTypeId(pType.Id, cs.stats.deliveredYesterday)}}
            </td>
            <td>
              {{getSummaryByPaymentTypeId(pType.Id, cs.stats.ordersPaidYesterday)}}
            </td>
            <td>
              {{getSummaryByPaymentTypeId(pType.Id, cs.stats.ordersDebtYesterday)}}
            </td>
            <td>
              {{getSummaryByPaymentTypeId(pType.Id, cs.stats.ordersFullDebt)}}
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </template>
    <table class="table table-sm table-bordered table-responsive small d-table-cell w-auto text-center">
      <thead>
      <tr>
        <th colspan="4">итого</th>
      </tr>
      <tr>
        <th width="100">
          Всего долг
        </th>
        <th width="100">
          Всего получено
        </th>
        <th width="100">
          Расходы
        </th>
        <th width="100">
          На руках
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          {{allDebt.CountOrder}}
        </td>
        <td>
          {{allPaid.CountOrder}}
        </td>
        <td> - </td>
        <td> - </td>
      </tr>
      <tr>
        <td>
          {{allDebt.CountAmount}}
        </td>
        <td>
          {{allPaid.CountAmount}}
        </td>
        <td> - </td>
        <td> - </td>
      </tr>
      <tr v-for="(pType, index) in report.pTypes">
        <td>
          {{allDebt.ptDebts[index]}}
        </td>
        <td>
          {{allPaid.ptDebts[index]}}
        </td>
        <td>
          {{report.TodayExpense[pType.Id] || 0}}
        </td>
        <td>{{(report.AllPaid[index] || 0) - (report.AllPaid[AllExpense] || 0)}}</td>
      </tr>
      </tbody>
    </table>
    </div>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';

const defaultDateFrom = moment().format('YYYY-MM-DD');
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      date: defaultDateFrom,
      report: {
        categoryStats: {},
      },
    };
  },
  mounted() {
    this.fetchDayReport();
  },
  watch: {
    date(newVal) {
      this.report = {};
      if (newVal) {
        this.fetchDayReport();
      }
    },
  },
  computed: {
    allDebt() {
      const CountOrder = _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, ofd => +ofd.CountOrder));
      const CountAmount = _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, ofd => +ofd.CountAmount));
      const ptDebts = _.map(this.report.pTypes, pt => _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersFullDebt, (ofd) => {
        if (ofd.PaymentTypeId === pt.Id) {
          return +ofd.CountSummary;
        }
        return 0;
      })));
      return {
        CountOrder,
        CountAmount,
        ptDebts,
      };
    },
    allPaid() {
      const CountOrder = _.sumBy(
        this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, ofd => +ofd.CountOrder) + _.sumBy(cs.stats.ordersDebtYesterday, ofd => +ofd.CountOrder),
      );
      const CountAmount = _.sumBy(
        this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, ofd => +ofd.CountAmount) + _.sumBy(cs.stats.ordersDebtYesterday, ofd => +ofd.CountAmount),
      );
      const ptDebts = _.map(
        this.report.pTypes, pt => _.sumBy(this.report.categoryStats, cs => _.sumBy(cs.stats.ordersPaidYesterday, (ofd) => {
          if (ofd.PaymentTypeId === pt.Id) {
            return +ofd.CountSummary;
          }
          return 0;
        })
        + _.sumBy(cs.stats.ordersDebtYesterday, (ofd) => {
          if (ofd.PaymentTypeId === pt.Id) {
            return +ofd.CountSummary;
          }
          return 0;
        })),
      );
      return {
        CountOrder,
        CountAmount,
        ptDebts,
      };
    },
  },
  methods: {
    sumCountOrder(stats) {
      return _.sumBy(stats, 'CountOrder');
    },
    sumCountAmount(stats) {
      return _.sumBy(stats, o => +o.CountAmount);
    },
    getSummaryByPaymentTypeId(paymentTypeId, stats) {
      const ptStats = _.findLast(stats, n => n.PaymentTypeId === paymentTypeId);
      return ptStats ? ptStats.CountSummary : 0;
    },
    async fetchDayReport() {
      console.log(this.date);
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/flow/table-data/${this.date}`);
      this.report = data;
      console.log(this.report);
    },
  },
};
</script>
